import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '2020两会圆桌';

const route: RouteConfig = {
  path: '/20200109LHYZ',
  name: 'LHYZ',
  component: () => import('./Home.vue'),
  redirect: '/20200109LHYZ/first',
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'first',
      component: () => import('./First.vue'),
      name: 'One',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'desk',
      component: () => import('./Desk.vue'),
      name: 'Two',
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
